import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BugReportButtonComponent } from './bug-report-button/bug-report-button.component';
import { ScreenshotAnnotatorComponent } from './screenshot-annotator/screenshot-annotator.component';

@NgModule({
  declarations: [
    BugReportButtonComponent,
    ScreenshotAnnotatorComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule
  ],
  exports: [
    BugReportButtonComponent
  ]
})
export class BugReportModule { }
